import Vue from 'vue';
import VueResource from 'vue-resource';
import router from '@/router';

Vue.use(VueResource);

export const fncPopulateRoles = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.userRoles == '' || (payload != undefined && payload.reload == true) || (payload != undefined && payload.refresh == true)) {
		// var objAuth = JSON.parse(rootState.objAuthorize);
    if( rootState.objAuthorize.length > 0 ) {
      var objAuth = JSON.parse(rootState.objAuthorize);
    } else {
      var objAuth = [];
    }

    if( router.history.current.query.manufacturer != null ) {
      var role_details = { a: 'getAll', manu: router.history.current.query.manufacturer };
    } else {
      var role_details = { a: 'getAll', manu: objAuth.manufacturer };
    }

		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Role.php', { params: role_details }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				console.log(error);
			}).then(data => {

				var objRoles = [];
				var n = 1;
				for (var k in data) {
					data[k].level = n;
					n++;
				}
				commit('setUserRoles', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Roles reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
};

export const fncReorderRoles = ({ commit, dispatch, state, rootState }, payload) => {
	commit({
		type: 'fncResetRoles',
		newIndex: payload.end,
		oldIndex: payload.start
	});
	for (var k in state.userRoles) {
		dispatch({
			type: 'fncEditRole',
			role: state.userRoles[k],
            reload: false
		});
	}
	commit('fncSetRoles', state.userRoles);
	dispatch({
		type: 'fncPopulateRoles',
		refresh: true
	})
	var snackDetails = { color: 'success', message: 'The role order was updated successfully', display: true };
	commit('setSnack', snackDetails);
}

export const fncRoleDelete = ({commit, dispatch, state, rootState}, payload) => {
	var roleDetails = {id: payload.roleId}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=delete', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The role could not be removed, please try again', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = {color: 'success', message: 'The role was removed successfully', display: true};
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateRoles',
				refresh: true
			})
		});
}

export const fncAddRole = ({commit, dispatch, state, rootState},payload) => {
    commit('setRunAdd', true);
	var isActive = 0;
	if( payload.roleDetails.roleActive === true ) {
		isActive = 1;
	}
	var objAuth = JSON.parse(rootState.objAuthorize);
	var roleDetails = {
		active: isActive,
		name: payload.roleDetails.roleName,
		description: payload.roleDetails.roleDescription,
		level: 99,
		user_type: parseInt(payload.roleDetails.roleUserType),
		current_user_id: objAuth.id,
		current_user_manu: objAuth.manufacturer,
    is_commercial_kam: payload.roleDetails.roleCommercialKam == true ? 1 : 0,
    is_commercial_originator: payload.roleDetails.roleCommercialOriginator == true ? 1 : 0
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=create', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The role could not be added, please try again', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = {color: 'success', message: 'The role was added successfully', display: true};
			commit('hideModal');
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulateRoles',
                refresh: true
			})
            commit('setRunAdd', false);
		});
}

export const fncEditRole = ({commit, dispatch, state, rootState}, payload) => {
	state.runAdd = true;
	var isActive = 0;
	if( payload.role.active == true || payload.role.active == 'Yes' ) {
		isActive = 1
	}
	var roleDetails = {
		id: payload.role.id,
		active: isActive,
		name: payload.role.name,
		description: payload.role.description,
		level: payload.role.level,
		user_type: payload.role.user_type,
		is_commercial_kam: payload.role.is_commercial_kam,
    is_commercial_originator: payload.role.is_commercial_originator
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=edit', roleDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The role could not be edited, please try again', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if (payload.reload == undefined ) {
				if (!data.hasOwnProperty('error')) {
					var snackDetails = { color: 'success', message: 'The role was edited successfully', display: true };
					commit('hideModal');
					commit('setSnack', snackDetails);
					dispatch({
						type: 'fncPopulateRoles',
						refresh: true
					})
				} else {
					var snackDetails = { color: 'error', message: 'The role could not be edited, please try again', display: true };
					commit('setSnack', snackDetails);
					dispatch({
						type: 'fncPopulateRoles',
						refresh: true
					})
				}
			}
		});
}

export const fncGetRolePlists = ({commit, dispatch, state, rootState}, payload) => {
	var plistDetails = { id: payload.roleId, manufacturer: payload.userManufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=get_role_pricelist', plistDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The price lists could not be retrieved', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('setObjRolePlists', data);
			Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					console.log(error);
				}).then(data => {
					var tokenDetails = { token: data.token, manufacturer_id: payload.userManufacturer, is_library_pricelist: 0};
					Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', {params: tokenDetails}, rootState.headerDetails)
						.then(response => {
							return response.json();
						}, error => {
							var snackDetails = {color: 'error', message: 'An error has occured', display: true};
						}).then(dt => {
							commit('setObjManuPlists', dt);
						});
				});
		});
}

export const fncUpdatePlists = ({commit, dispatch, state, rootState}) => {
	var roleId = state.objRoleEdit.id;
	var objPlists = [];
	for( var k in state.objManuPlists ) {
		if( state.objManuPlists[k].pl_active === true ) {
			objPlists.push(state.objManuPlists[k].pl_id);
		}
	}
	var plistDetails = {id: roleId, pricelists: objPlists };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=save_role_pricelist', plistDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The roles price lists could not be updated', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( data.msg === 'Success') {
				var snackDetails = {color: 'success', message: 'The roles price lists was successfully updated', display: true};
				commit('setSnack', snackDetails);
				commit('hideModal');
			}
		});
}

export const fncPopulateSubTabs = ({commit, dispatch, state, rootState}, payload) => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var privDetails = {manufacturer: objAuth.manufacturer };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=get_sub_tabs_statuses', {params: privDetails}, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error)
    }).then(data => {
    commit('fncTabs', data);
  });
}

export const fncGetRolePrivs = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var privDetails = {role: payload.roleId, current_user_manu: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=getLinkedPrivs', privDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The privileges could not be retrieved', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var privIds = [];
			for( var k in data ) {
				privIds.push( data[k].id );
			}
			commit({
				type: 'setObjRolePrivs',
				assigned: privIds,
				available: payload.privList
			})
			var modalDetails = { title: 'Role and Privilege Management - ' + payload.roleName, component: 'modal-role-privs', mstate: true, params: payload.roleId };
			commit({
				type: 'setModal',
				details: modalDetails
			});
		});
}

export const fncLinkRolePriv = ({commit, dispatch, state, rootState}, payload) => {
	var rolePrivDetails = {priv: payload.privId, role: payload.roleId, view_priv: 1, create_priv: 1, delete_priv: 1};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=linkPriv', rolePrivDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The role privilege could not be updated', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( !data.hasOwnProperty('error') ) {
				var snackDetails = {color: 'success', message: 'The role privilege was updated', display: true};
				commit('setSnack', snackDetails);
			} else {
				var snackDetails = {color: 'error', message: 'The role privilege could not be updated', display: true};
				commit('setSnack', snackDetails);
			}
		});
}

export const fncUninkRolePriv = ({commit, dispatch, state, rootState}, payload) => {
	var rolePrivDetails = {priv: payload.privId, role: payload.roleId};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=unlinkPriv', rolePrivDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The role privilege could not be unlinked', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( !data.hasOwnProperty('error') ) {
				var snackDetails = {color: 'success', message: 'The role was succesfully unlinked', display: true};
				commit('setSnack', snackDetails);
			} else {
				var snackDetails = {color: 'error', message: 'The role privilege could not be unlinked', display: true};
				commit('setSnack', snackDetails);
			}
		});
}

export const fncGetRoleStatus = ({commit, dispatch, state, rootState}, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var statusDetails = { id: payload, manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=get_role_status_details', statusDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The status could not be retrieved', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('fncGetRoleStatus', data);
			var modalDetails = { title: 'Manage Role RFC Status Links', component: 'modal-role-status', mstate: true, params: {roleId: payload} };
			commit({
				type: 'setModal',
				details: modalDetails
			});
	});
}



export const fncLinkRoleStatus = ({commit, dispatch, state, rootState}, payload) => {
	var statusDetails = { roleId: payload.roleId, status: payload.statusId, link: payload.link };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Role.php?a=link_role_status', statusDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'The status link could not be updated', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( data == true ) {
				var snackDetails = {color: 'success', message: 'The status link was updated successfully', display: true};
				commit('setSnack', snackDetails);
			} else {
				var snackDetails = {color: 'error', message: 'The status link could not be updated', display: true};
				commit('setSnack', snackDetails);
			}
		/*commit('fncGetRoleStatus', data);
		var modalDetails = { title: 'Manage Role RFC Status Links', component: 'modal-role-status', mstate: true };
		commit({
			type: 'setModal',
			details: modalDetails
		});*/
	});
}
